


























































































require("axios");
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import NewApi, { BasePath, ImagePath, ImageThumbPath } from "../ts/api";
import { DefaultApi, Image, Award } from "../api";
import draggable from "vuedraggable";
import Datepicker from "vuejs-datepicker";
import Modal from './Modal.vue'


let api: DefaultApi;

const AwardProps = Vue.extend({
  props: {
    id: Number
  }
});

@Component({
  components: {
    draggable,
    Datepicker,
    Modal
  }
})
export default class AwardManager extends AwardProps {
  awardImage = {} as Image;
  awards = [] as Award[];
  newAward = {} as Award;
  selectedAward = {} as Award;
  imgPool = [] as Image[];
  isDragging = false;

  showModal = false

  selDate = ""

  @Watch("awardImage") onAwardsChanged(value: Image, oldValue: Image) {}

  mounted() {
    api = NewApi();
    this.getAwards();
    this.getImages();
  }



setDate(d :string){
  console.log("update param date: "+ d)
  if(this.selectedAward){
    this.selectedAward.date = d
    this.updateAward()
  }
}

  get dragOptions() {
    return {
      animation: 0,
      group: "description",
      ghostClass: "ghost"
    };
  }

  getAwards() {
    var resp = api.awardGet();
    let ctx = this;
    resp
      .then(function(r) {
        ctx.awards = r.data;
      })
      .catch(e => console.error("failed to fetch awards"));
  }

  

  deleteAward(a :Award){
    let ctx = this
    api.awardDelete(a.id).then(function(r){
      ctx.getAwards()
      ctx.selectedAward = {} as Award
      }).catch(e => console.error("could not delete award: " + e))
  }

  selectImage(i: Image) {
    i.award_id = this.selectedAward.id;
    this.awardImage = i;
    this.selectedAward.image = i;
    this.updateAward();
    api.imagePut(i).catch(e => console.error("could not update image "));
  }

  createAward() {
    let ctx = this;
    if (this.newAward && this.newAward.title) {
      var resp = api.awardPost(this.newAward);
      resp
        .then(function(r) {
          ctx.newAward = {} as Award;
          ctx.getAwards();
        })
        .catch(e => console.error("failed to create gallery"));
    }
  }

  updateAward() {
    if (this.selectedAward) {
      var resp = api.awardPut(this.selectedAward);
      resp
        .then(r => this.getAwards())
        .catch(e => console.error("failed to update award"));
    }
  }

  selectAward(a: Award) {
    this.selectedAward = a;
    this.awardImage = a.image;
    this.selDate = a.date
  }

  getImagePath(s: string) {
    return ImageThumbPath(s);
  }

  getImages() {
    this.imgPool = [];
    let ctx = this;
    var resp = api.imageGet();
    resp
      .then(function(i) {
        for (let img in i.data) {
          if (i.data[img].award_id == 0) {
            ctx.imgPool.push(i.data[img]);
          }
        }

        ctx.imgPool.sort(function(a, b) {
          return a.order - b.order;
        });
      })
      .catch(e => console.log("fail to fetch images"));
  }
}
